module.exports = __webpack_public_path__ + "static/media/Email-Sent@1.5x.5fa1f24d.png";